import {
    FETCH_INTEGRATION_REQUESTED,
    FETCH_INTEGRATION_SUCCESS,
    FETCH_INTEGRATION_FAILURE,
    SET_DEFAULT_AUDIO_PROFILE,
    UPDATE_PRONUNCIATION_LIBRARY,
    CREATE_INTEGRATION_FAILURE,
    CREATE_INTEGRATION_REQUESTED,
    CREATE_INTEGRATION_SUCCESS,
} from "../actionTypes"

// ✨ Note: profiles state removed - now managed by React Query (useSavedProfiles)
const initialState = {
    integration: null,
    newIntegration: null,
    isLoading: false,
    isNewIntegrationLoading : false,
    isError: false,
    pronunciationLibrary: [],
};

export default function integrationReducer(state = initialState, action) {
    const { type } = action;

    switch (type) {
        case FETCH_INTEGRATION_SUCCESS:
            return {
                ...state,
                integration: action.payload,
                pronunciationLibrary: action.payload.pronunciation_library || [],
                isLoading: false,
                isError: false
            };

        case FETCH_INTEGRATION_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true
            };

        case FETCH_INTEGRATION_REQUESTED:
            return {
                ...state,
                isLoading: true
            };

        case CREATE_INTEGRATION_SUCCESS:
            console.log(CREATE_INTEGRATION_SUCCESS, "reducer")
            return {
                ...state,
                newIntegration: action.payload,
                isNewIntegrationLoading: false,
                isError: false
            };

        case CREATE_INTEGRATION_FAILURE:
            return {
                ...state,
                isNewIntegrationLoading: false,
                isError: true
            };

        case CREATE_INTEGRATION_REQUESTED:
            return {
                ...state,
                newIntegration : null,
                isNewIntegrationLoading: true,
                isError : false
            };

        // ✨ Profile cases removed - migrated to React Query:
        // - FETCH_INTEGRATION_PROFILES_* → useSavedProfiles hook
        // - DELETE_AUDIO_PROFILE_* → useDeleteProfile hook

        case UPDATE_PRONUNCIATION_LIBRARY:
            return {
                ...state,
                pronunciationLibrary: action.payload
            }

        case SET_DEFAULT_AUDIO_PROFILE:
            return {
                ...state,
                integration: {
                    ...state.integration,
                    audio_profile: action.payload
                }
            }

        default:
            return state;
    }
}
